module.exports = __webpack_public_path__ + "static/media/CogIcon.41f89b4b.svg";